"use client";

import React from "react";
import { twMerge } from "tailwind-merge";

interface IListWithShowMoreProps {
  children: React.ReactNode;
  showMore?: boolean;
  showLess?: boolean;
  onShowMore?: () => void;
  onShowLess?: () => void;
  showMoreText?: string;
  showLessText?: string;
  containerClassName?: string;
  buttonContainerClassName?: string;
  paginationButtonClassName?: string;
}

const DEFAULT_PAGINATION_BUTTON_CLASS =
  "h-[40px] p-[10px] md:h-[40px] md:min-w-[258px] md:px-[24px] md:py-[12px] rounded-[23px] text-[14px] font-medium text-link-primary border-link-primary border flex justify-center items-center cursor-pointer hover:bg-link-primary hover:text-white transition-colors max-sm:w-full";

export const STOCK_LISTING_PAGINATION_BUTTON_CLASS =
  "md:pt-[12px] md:pr-[24px] md:pb-[11px] md:pl-[24px]";

const ListWithShowMore: React.FC<IListWithShowMoreProps> = ({
  children,
  showMore = false,
  showLess = false,
  onShowMore,
  onShowLess,
  showMoreText = "Show More",
  showLessText = "Show Less",
  containerClassName = "",
  buttonContainerClassName = "",
  paginationButtonClassName,
}) => {
  const buttonClassName = paginationButtonClassName
    ? twMerge(DEFAULT_PAGINATION_BUTTON_CLASS, paginationButtonClassName)
    : DEFAULT_PAGINATION_BUTTON_CLASS;

  return (
    <div className={containerClassName}>
      {children}
      
      {(showMore || showLess) && (
        <div className={`flex justify-center gap-4 mt-4 max-w-[850px] ${buttonContainerClassName}`}>
          {showMore && (
            <button
              type="button"
              onClick={onShowMore}
              className={buttonClassName}
            >
              {showMoreText.toLocaleUpperCase()}
            </button>
          )}
          {showLess && (
            <button
              type="button"
              onClick={onShowLess}
              className={buttonClassName}
            >
              {showLessText.toLocaleUpperCase()}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ListWithShowMore;
